import { createSlice } from "@reduxjs/toolkit";

const timerId=createSlice({
  name:"timerId",
  initialState:{timerId:null},
  reducers:{
    setStartTimer(state, action) {
      state.timerId = action.payload;
    },
    setStopTimer(state) {
      if (state.timerId) {
        state.timerId = null;
      }
    },
  }
});

export const { setStartTimer, setStopTimer }=timerId.actions
export default timerId.reducer